import { useNavigate, useSearchParams } from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import {ApiContext} from "../contexts/ApiContext";
import FormLayout from "../../layouts/FormLayout";
import H1Header from "../headers/h1";
import TextInput from "../input/TextInput";
import PasswordInput from "../input/PasswordInput";
import DefaultButton from "../buttons/DefaultButton";


function SetPasswordPage() {
    const {Url } = useContext(ApiContext)
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const [email, setEmail] = useState(searchParams.get('email') || '')
    const [token, setToken] = useState(searchParams.get('token') || '')
    const [password, setPassword] = useState('')
    const [step, setStep] = useState(1)
    const [message, setMessage] = useState('')

    useEffect(() => {
        if (searchParams.get('email')) {
            setEmail(searchParams.get('email') || '');
        }
        if (searchParams.get('token')) {
            setToken(searchParams.get('token') || '');
        }
    }, [searchParams]);

    function handleSetPassword(event: React.FormEvent) {
        event.preventDefault()
        setMessage('Bezig met het instellen van je wachtwoord...')
        fetch(Url + 'password/reset', {
            method: 'POST',
            headers: {
                'content-type': 'application/json',
            },
            body: JSON.stringify({
                email: email.toLowerCase(),
                token: token.replace(/\s/g,''), //Remove all whitespace
                password: password
            }),
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.message === 'Password reset done') {
                    setStep(2)
                    setPassword('')
                    setEmail('')
                    setToken('')
                } else if (data.message === 'Validation failed for field: Password'){
                    setMessage('Het opgegeven wachtwoord is niet lang genoeg. Het moet minimaal 10 karakters bevatten.')
                }
                else{
                    setMessage('Het instellen van je wachtwoord is mislukt. Controleer de link in je mail of vraag een nieuwe aan.')
                }
            })
            .catch(() => {
                setMessage('Er is een fout opgetreden bij het verbinden met de server.')
            })
    }

    function goToLoginPage(){
        navigate("/login", { replace: true })
    }

    if (step === 1){
        return (
            <FormLayout>
                <form onSubmit={handleSetPassword}>
                    <H1Header headerText="Wachtwoord instellen" ></H1Header>
                    <div className="mb-4 mt-4 max-w-[30rem]">
                        Welkom bij Groteboek! Stel hier je wachtwoord in om je account te activeren. 
                        Je wachtwoord dient minimaal 10 karakters lang te zijn.
                    </div>
                    <p className="text-base leading-relaxed text-red-500">
                        {message}
                    </p>
                    <TextInput
                        labelName="Emailadres"
                        inputName="email"
                        placeholder="Email"
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                        pattern={undefined}
                        type="email"
                        errorMessage={"Vul een geldig mailadres in"}>
                    </TextInput>
                    <TextInput
                        labelName="Token"
                        inputName="token"
                        placeholder="Token"
                        onChange={(e) => setToken(e.target.value)}
                        value={token}
                        pattern={undefined}
                        type="text"
                        errorMessage={"Vul de token uit de mail in."}>
                    </TextInput>
                    <PasswordInput labelName="Nieuw Wachtwoord" value={password} inputName="password"
                                   onChange={(e) => setPassword(e.target.value)}
                                   errorMessage="Ongeldig wachtwoord, je wachtwoord moet minimaal 10 tekens lang zijn"
                                   pattern=".{10,}"/>
                    <div className=" mt-4 flex justify-end">
                        <DefaultButton content="Wachtwoord instellen" onClick={handleSetPassword}></DefaultButton>
                    </div>
                </form>
            </FormLayout>
        );
    }

    if (step === 2) {
        return (
            <FormLayout>
                <H1Header headerText="Gelukt!" ></H1Header>
                <div className="m-4 max-w-[30rem]">
                    Je wachtwoord is succesvol ingesteld. Je kunt nu inloggen met je mailadres en het nieuwe wachtwoord.
                </div>
                <div className="m-4 flex justify-end">
                    <DefaultButton content="Inloggen" onClick={goToLoginPage}></DefaultButton>
                </div>
            </FormLayout>
        );
    }
    return null;
}

export default SetPasswordPage;
